.avatar {
  display: inline-flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: var(--radius-full);
  border: 1px solid var(--color-border-strong);
  background-color: var(--color-surface-2);
  color: var(--color-text);
  font-family: var(--font-display);
  font-weight: var(--font-weight-semibold);
  letter-spacing: 0.02em;
}

.photo {
  width: 100%;
  height: 100%;
  border-radius: inherit;
  /* Fills the circle without squashing a portrait or a landscape photo. */
  object-fit: cover;
}

.sm {
  width: 2rem;
  height: 2rem;
  font-size: var(--font-size-xs);
}

.md {
  width: 2.5rem;
  height: 2.5rem;
  font-size: var(--font-size-sm);
}

.lg {
  width: 3.5rem;
  height: 3.5rem;
  font-size: var(--font-size-lg);
}

.xl {
  width: 5rem;
  height: 5rem;
  font-size: var(--font-size-2xl);
}

/* The member profile's photo. */
.xxl {
  width: 7rem;
  height: 7rem;
  font-size: var(--font-size-3xl);
}
